let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hJ4H6")).then(() => parcelRequire('2BECp'));